/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetGcpSetupInfoSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type GetGcpSetupInfoRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type GetGcpSetupInfoSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const GetGcpSetupInfoSecurity$outboundSchema: z.ZodMiniType<
  GetGcpSetupInfoSecurity$Outbound,
  GetGcpSetupInfoSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getGcpSetupInfoSecurityToJSON(
  getGcpSetupInfoSecurity: GetGcpSetupInfoSecurity,
): string {
  return JSON.stringify(
    GetGcpSetupInfoSecurity$outboundSchema.parse(getGcpSetupInfoSecurity),
  );
}

/** @internal */
export type GetGcpSetupInfoRequest$Outbound = {
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const GetGcpSetupInfoRequest$outboundSchema: z.ZodMiniType<
  GetGcpSetupInfoRequest$Outbound,
  GetGcpSetupInfoRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
    });
  }),
);

export function getGcpSetupInfoRequestToJSON(
  getGcpSetupInfoRequest: GetGcpSetupInfoRequest,
): string {
  return JSON.stringify(
    GetGcpSetupInfoRequest$outboundSchema.parse(getGcpSetupInfoRequest),
  );
}
